// Daily driving distances for mainland China destinations (in km)
// drivingDistancesMap[destinationId][dayNumber] = distance driven that day (0 if rest/city day)

export const drivingDistancesMap: Record<number, Record<number, number>> = {
  1: { // 川藏線 成都→拉薩 全程約2100km
    1: 160,
    2: 220,
    3: 80,
    4: 170,
    5: 250,
    6: 180,
    7: 200,
    8: 220,
    9: 400,
    10: 50,
  },
  2: { // 青海湖環線 全程約830km
    1: 100,
    2: 300,
    3: 180,
    4: 150,
    5: 100,
  },
  3: { // 獨庫公路 全程約1450km
    1: 50,
    2: 280,
    3: 320,
    4: 50,
    5: 80,
    6: 240,
    7: 160,
    8: 270,
  },
  4: { // 海南島環島 全程約900km
    1: 100,
    2: 200,
    3: 100,
    4: 150,
    5: 50,
    6: 300,
  },
  5: { // 雲南環線 昆明→大理→麗江→香格里拉 全程約1600km
    1: 400,
    2: 120,
    3: 180,
    4: 60,
    5: 180,
    6: 80,
    7: 580,
  },
  6: { // 內蒙古草原 全程約890km
    1: 100,
    2: 30,
    3: 250,
    4: 150,
    5: 200,
    6: 160,
  },
  7: { // 絲綢之路 西安→敦煌 全程約2500km
    1: 350,
    2: 200,
    3: 320,
    4: 190,
    5: 150,
    6: 360,
    7: 30,
    8: 20,
    9: 15,
  },
  8: { // 桂林山水環線 全程約470km
    1: 100,
    2: 80,
    3: 60,
    4: 200,
    5: 30,
  },
  9: { // 張家界 全程約390km
    1: 100,
    2: 40,
    3: 30,
    4: 20,
    5: 200,
  },
  10: { // 東北雪鄉 全程約730km
    1: 100,
    2: 20,
    3: 230,
    4: 120,
    5: 90,
    6: 170,
  },
  11: { // 福建土樓 全程約980km
    1: 400,
    2: 180,
    3: 200,
    4: 200,
  },
  12: { // 西藏珠峰 拉薩環線 全程約1670km
    1: 20,
    2: 30,
    3: 360,
    4: 30,
    5: 250,
    6: 100,
    7: 100,
    8: 160,
    9: 260,
    10: 280,
    11: 30,
    12: 50,
  },
  13: { // 九寨溝 成都往返 全程約975km
    1: 450,
    2: 30,
    3: 25,
    4: 20,
    5: 450,
  },
  14: { // 新疆喀納斯 全程約1030km
    1: 100,
    2: 150,
    3: 40,
    4: 40,
    5: 50,
    6: 150,
    7: 500,
  },
  15: { // 張掖丹霞 蘭州→敦煌 全程約1080km
    1: 100,
    2: 300,
    3: 180,
    4: 120,
    5: 380,
  },
  16: { // 貴州黔東南 全程約790km
    1: 80,
    2: 200,
    3: 30,
    4: 100,
    5: 80,
    6: 300,
  },
  17: { // 川西秘境 全程約2090km
    1: 200,
    2: 300,
    3: 290,
    4: 250,
    5: 180,
    6: 200,
    7: 220,
    8: 400,
    9: 50,
  },
  18: { // 甘南藏區 蘭州環線 全程約1160km
    1: 250,
    2: 50,
    3: 130,
    4: 100,
    5: 70,
    6: 180,
    7: 380,
  },
  19: { // 恩施大峽谷 全程約950km
    1: 360,
    2: 50,
    3: 60,
    4: 80,
    5: 400,
  },
  20: { // 婺源 南昌往返 全程約500km
    1: 250,
    2: 250,
  },
};

export const totalDistancesMap: Record<number, number> = Object.fromEntries(
  Object.entries(drivingDistancesMap).map(([id, days]) => [
    Number(id),
    Object.values(days).reduce((sum, d) => sum + d, 0),
  ])
);
